
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/concierge/yacht",
      function () {
        return require("private-next-pages/concierge/yacht/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/concierge/yacht"])
      });
    }
  